module.exports = __webpack_public_path__ + "img/theme-g.e3af1d83.png";